import { Model } from '@vuex-orm/core';
import Zaui from '@/include/api';

export default class Category extends Model {
  static entity = 'categories';

  get imageUrl() {
    return this.image ? this.image : require('@/assets/images/abstract.png');
  }

  static fields() {
    return {
      id: this.number(),
      type: this.attr(''),
      name: this.attr(''),
      description: this.attr(''),
      image: this.attr(''),
      count: this.attr(0),
      webSortPriority: this.number()
    };
  }

  static fetch(type, id) {
    return Zaui[type].category(id).then(data => {
      Category.insert({ data });
    });
  }

  static fetchCategories(type, date) {
    return Zaui[type].categories(date).then(data => {
      Category.insert({ data });
    });
  }
}